module.exports = __webpack_public_path__ + "img/Gallery_2_38.e72257ef.jpeg";